@import '@hevoio/hevo-ui-toolkit/styles/variables';

.pipelineNodesImg {
  width: 20px;
  height: 20px;
}

.upgradePipelineBannerContainer {
  width: 100%;
  max-width: 900px;
  margin: $spacer-20 auto $spacer-12;
  position: relative;
  display: flex;
}

.upgradePipelineBanner {
  width: 0;
  flex: 1;
  padding-left: $spacer * 1.25;
  padding-right: $spacer * 1.25;
}
